import React, { KeyboardEventHandler } from "react";
import Icon from "src/components/icon";
import { toYYYYMMDD } from "src/utils/datefns";

/**
 * Custom input for date range pickers
 */
export default class DateRangePickerCustomInput extends React.Component<{
    startPlaceholder: string,
    endPlaceholder: string,
    locale?: string,
    startDate: Date | undefined,
    endDate: Date | undefined,
    onClick?: any,
    keyboardDisabled: boolean,
    className?: string,
    fontClassname?: string
}> {

    static defaultProps = {
        keyboardDisabled: false,
    }

    onKeyDown: KeyboardEventHandler<HTMLInputElement> = (e) => {
        if (e.nativeEvent.code === "Space" || e.nativeEvent.code === "Enter") {
            this.props.onClick();
        }
    }

    formatDate(date: Date | undefined, defaultText: string) {
        if (!date) return defaultText;
        try {
            const dateformatter = new Intl.DateTimeFormat(this.props.locale || 'en-US', { weekday: 'short', day: 'numeric', month: 'short', });
            return dateformatter.format(date);
        } catch (err) {
            // too old navigators.
            return toYYYYMMDD(date);
        }
    }

    render() {
        return <>
        <div className="relative">
            <input
                id={`date-range-picker-custom-input-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`}
                name={`date-range-picker-custom-input-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`}
                type="text"
                className={`${this.props.keyboardDisabled ? "pointer-events-none" : ""} w-full md:cursor-pointer rounded-lg border-1 border-[color:var(--input-border-color)] bg-[color:var(--input-background-color)] appearance-none block peer h-10 ${this.props.className || ""}`}
                value=""
                onKeyDown={this.onKeyDown}
                onChange={(e)=>void 0}
            />
            <div onClick={this.props.onClick} className="absolute top-0 bottom-0 left-0 right-0 flex flex-row items-center px-4">
                <span className={`flex-1 caption text-left ${this.props.fontClassname} ${this.props.startDate ? 'text-[color:var(--input-text-color)]' : 'text-[color:var(--input-placeholder-color)]'}`}>
                    {this.formatDate(this.props.startDate, this.props.startPlaceholder)}
                </span>
                <span> <Icon className="w-6 h-6 text-[color:var(--input-chevron-color)]" icon="ArrowRight" /> </span>
                <span className={`flex-1 caption text-right ${this.props.fontClassname} ${this.props.endDate ? 'text-[color:var(--input-text-color)]' : 'text-[color:var(--input-placeholder-color)]'}`}>
                    {this.formatDate(this.props.endDate, this.props.endPlaceholder)}
                </span>
            </div>
        </div>
        </>
    }
}